export default __webpack_public_path__ + "static/media/11.5b2e88f5.svg";